import { Box } from '@mui/material';
import { SyntheticEvent, useState } from 'react';
import CustomTab from '../../shared/CustomTab/CustomTab';
import { RolesAndPermission } from './components/RolesAndPermission';
import UserManagement from './components/UserManagement/UserManagement';
import Integration from './components/Integration';

export const AdminPanel = () => {
  const currentAdminConsoleTab = sessionStorage.getItem('currentAdminConsoleTab') || 0;
  const [value, setValue] = useState(+currentAdminConsoleTab);

  const handleChange = (_: SyntheticEvent, newValue: number) => {
    sessionStorage.setItem('currentAdminConsoleTab', newValue.toString());
    setValue(newValue);
  };

  const Tabs = [
    {
      label: 'User Management',
      id: 1,
      isHidden: value !== 0,
      Component: (
        <Box>
          <UserManagement />
        </Box>
      ),
    },
    {
      label: 'Roles & Permission',
      id: 2,
      isHidden: value !== 1,
      Component: <RolesAndPermission />,
    },
    {
      label: 'Integration',
      id: 3,
      isHidden: value !== 2,
      Component: <Integration />,
    },
  ];
  return (
    <Box sx={{ padding: { xs: '20px 16px 0rem 16px', xl: '24px 1.5rem 0rem 1.5rem' } }}>
      {' '}
      <CustomTab tabs={Tabs} handleChange={handleChange} value={value} />
    </Box>
  );
};
